// Fuentes de las imágenes
const images = [
    'https://cdn.shopify.com/s/files/1/0703/6993/5556/files/curriculum6.jpg',
    'https://cdn.shopify.com/s/files/1/0703/6993/5556/files/testimonio1.jpg',
    'https://cdn.shopify.com/s/files/1/0703/6993/5556/files/testimonio2.jpg',
    'https://cdn.shopify.com/s/files/1/0703/6993/5556/files/testimonio3.jpg',
    'https://cdn.shopify.com/s/files/1/0703/6993/5556/files/curriculum5.jpg',
    'https://cdn.shopify.com/s/files/1/0703/6993/5556/files/curriculum4.jpg'
];

// Busca el elemento raíz donde se debe construir el carrusel
const root = document.getElementById('swiper-root');

// ----- INICIO DE LA CORRECCIÓN -----
// Solo ejecuta el código del carrusel si el elemento 'root' existe en la página actual.
if (root) { 
    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper';
    root.appendChild(swiperContainer);

    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';
    swiperContainer.appendChild(wrapper);

    // Genera las slides
    images.forEach(src => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        const img = document.createElement('img'); img.src = src;
        slide.appendChild(img);
        wrapper.appendChild(slide);
    });

    // Inicializa Swiper
    new Swiper('.swiper', {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 20,
        autoplay: { delay: 1000, disableOnInteraction: false },
        breakpoints: {
            320: { slidesPerView: 1, spaceBetween: 10 },
            640: { slidesPerView: 2, spaceBetween: 15 },
            1024: { slidesPerView: 3, spaceBetween: 20 }
        }
    });
}
// ----- FIN DE LA CORRECCIÓN -----


// El resto del código para los videos no necesita cambios, 
// ya que no genera un error si no encuentra los elementos.
const containers = document.querySelectorAll('.video-testimonio');
containers.forEach(container => {
    const video = container.querySelector('video');
    container.addEventListener('click', () => {
        // Pausa otros videos
        containers.forEach(other => {
            const otherVideo = other.querySelector('video');
            if (other !== container && !otherVideo.paused) {
                otherVideo.pause();
                other.classList.remove('playing');
            }
        });
        // Inicia/pausa el video clickeado
        if (video.paused) {
            video.play();
            container.classList.add('playing');
        } else {
            video.pause();
            container.classList.remove('playing');
        }
    });
});